import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, isRef as _isRef, unref as _unref, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"
import _imports_0 from './../assets/Cambridge_Strip_Elevation.jpg'
import _imports_1 from './../assets/Edinburgh_Strip_Elevation.jpg'
import _imports_2 from './../assets/Nottingham_Strip_Elevation.jpg'
import _imports_3 from './../assets/view.png'
import _imports_4 from '../assets/button-download-icon.svg'
import _imports_5 from '../assets/elevator-icon.svg'
import _imports_6 from './../assets/plus-circle.svg'
import _imports_7 from './../assets/minus-circle.svg'
import _imports_8 from './../assets/sync-alt.svg'


const _hoisted_1 = { class: "site_plan" }
const _hoisted_2 = {
  key: 0,
  class: "leftPanel"
}
const _hoisted_3 = { class: "select_form" }
const _hoisted_4 = { class: "model_selection_header" }
const _hoisted_5 = { class: "radio_selection" }
const _hoisted_6 = { class: "price_text" }
const _hoisted_7 = { class: "pic_holder" }
const _hoisted_8 = { class: "price_text" }
const _hoisted_9 = { class: "pic_holder" }
const _hoisted_10 = { class: "price_text" }
const _hoisted_11 = { class: "pic_holder" }
const _hoisted_12 = { class: "select_form" }
const _hoisted_13 = { class: "checkbox-group" }
const _hoisted_14 = {
  key: 1,
  class: "topPanel"
}
const _hoisted_15 = { class: "midPanel" }
const _hoisted_16 = { id: "buttonSide" }
const _hoisted_17 = { class: "actionButton" }
const _hoisted_18 = { class: "actionButton" }
const _hoisted_19 = { class: "actionButton" }
const _hoisted_20 = {
  key: 2,
  class: "bottomPanel"
}
const _hoisted_21 = { class: "select_form" }
const _hoisted_22 = { class: "model_selection_header" }
const _hoisted_23 = { class: "radio_selection" }
const _hoisted_24 = { class: "price_text" }
const _hoisted_25 = { class: "pic_holder" }
const _hoisted_26 = { class: "price_text" }
const _hoisted_27 = { class: "pic_holder" }
const _hoisted_28 = { class: "price_text" }
const _hoisted_29 = { class: "pic_holder" }
const _hoisted_30 = { class: "select_form" }
const _hoisted_31 = { class: "checkbox-group" }
const _hoisted_32 = { class: "lotName" }
const _hoisted_33 = { class: "modalAboveImageText" }
const _hoisted_34 = { class: "modalFloorplanName" }
const _hoisted_35 = {
  key: 0,
  class: "modalInfotext"
}
const _hoisted_36 = { class: "modalInfotext" }
const _hoisted_37 = ["src"]
const _hoisted_38 = ["href"]

import axios from "axios";
import { onMounted, ref, watch } from "vue";
import Panzoom from "@panzoom/panzoom";
import { appStore } from "@/stores/app-store";
import { BuildingData } from "@/stores/app-state";
import UnitModal from '@/components/UnitModal.vue';
import FilterModal from '@/components/FilterModal.vue';
import LoadingModal from '@/components/LoadingModal.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'SitePlanComponent',
  setup(__props) {

const store = appStore();

const svgImgSrc = ref();
const svgDiv = ref();
const a1 = ref();
const c1 = ref();
const e1 = ref();
const n1 = ref();



const showUnitModal = ref(false);
const showEmbedForm = ref(false);
const showFilterModal = ref(false);
const selectedLotId = ref('');
const modalTitleText = ref();
const lotPriceText = ref();
const lotBedroomsText = ref();
const lotBathroomsText = ref();
const lotSizeText = ref();
const lotParkingSpaceText = ref();
const lotFloorplanName = ref('');
const lotUnitInfoText = ref();

const showLoadingModal = ref(false);

const zoomInRef = ref();
const zoomOutRef = ref();
const zoomResetRef = ref();
const siteplanImgContainer = ref();
const controlRightOffest = ref('15px');

const cambridgePrice = ref("From $1.2M");
const edinburghPrice = ref("From $1.4M");
const nottinghamPrice = ref("From $1.5M");

let unitsAvailable = ref(0);
let currentFloorplanIndex = ref(0);

let panning = false;
let panzoom:any;

let floorplan = ref(store.floorplanFilter);
let status = ref(store.statusFilter);
const showOnlyElevator = ref(false);

const isWideScreen = ref(true);

let theBarnLogoElement:any;

watch(showUnitModal, (newShow, oldShow) => {
    if(newShow){
      document.body.classList.add("modal-open");
    }else{
      document.body.classList.remove("modal-open");
    }
});

onMounted(() => {
    // let svgSource = svgImgSrc.value.src;
    var svgHtml = document.querySelector('#svgImage');
    axios.get("NS_Siteplan.svg").
    then((data:any) => {
        store.siteSVG = data.data;
        svgDiv.value.innerHTML = store.siteSVG;
        initPanzoom();
        axios.get("https://homedesigner.truevistavr.com/siteplanAPI/siteplan/NS")
          .then((data:any) => {
           store.unitsData = data.data;
            updateBuildingPhaseData();
            iterateSVG();
          });
    });
    window.addEventListener("resize", windowResizeChange);
    windowResizeChange();
    axios.get("https://homedesigner.truevistavr.com/siteplanAPI/prices/3")
          .then((data:any) => {
            data.data.forEach((element:any) => {
              switch(element.name){
                case 'The Aberdeen':
                  break;
                case 'The Cambridge':
                  cambridgePrice.value = element.pricing;
                  break;
                case 'The Edinburgh':
                  edinburghPrice.value = element.pricing;
                  break;
                case 'The Nottingham':
                  nottinghamPrice.value = element.pricing;
                  break;
                default:
                  break;
              }
            });
           });
});

const windowResizeChange = () => {
  if(siteplanImgContainer.value.clientWidth > siteplanImgContainer.value.clientHeight){
    controlRightOffest.value = 
    ((siteplanImgContainer.value.clientWidth - siteplanImgContainer.value.clientHeight) / 2) + 15 + "px";
  }else{
    controlRightOffest.value = "15px";
  }
  isWideScreen.value = window.innerWidth >= 1024;// || (window.matchMedia("(orientation: landscape)").matches);
};
function updateBuildingPhaseData(){
  let futurePhaseDate = store.futurePhaseBuildings;
  futurePhaseDate.forEach(building => {
    let enabled = true;
    store.unitsData.every(unit=>{
      if(+unit.unitId >= building.startUnit && +unit.unitId <= building.endUnit
      && unit.status != "ComingSoon"){
          enabled = false;
          return false;
      }
      return true;  
    });
    building.enabled = enabled;
  });
}

function filterModelChange(newFilter:string){
  if(floorplan.value == newFilter){
    floorplan.value = "";
  }else{
    floorplan.value = newFilter;
  }
  console.log("Filter changed");
  store.floorplanFilter = floorplan.value;
  iterateSVG();
}

function filterStatusChange(){
  store.statusFilter = status.value != "All"? status.value : "";
  if(status.value == "All"){
    status.value = "";
  }
  //var startTime = performance.now();
  iterateSVG();
  //var endTime = performance.now();
  //console.log(`Call to doSomething took ${endTime - startTime} milliseconds`);
}


function iterateSVG() {
    var svgHtml = document.querySelector('#svgImage');
    //svgHtml!.innerHTML = store.siteSVG; //TODO remove this line to increase peformance by 50-100x times but need to deal with sold circles then.
    unitsAvailable.value = 0;

    let svg = svgDiv.value.children[0];
    svg.querySelectorAll('circle').forEach((element:any) => {
      let elementClass = element.getAttribute('class');
      if(elementClass == "tempCircle"){
        element.remove();
      }
    });

    svg.querySelectorAll('g').forEach((element:any) => {
    let elementID = element.getAttribute('id');

    if(elementID == null)
      return;

      if(elementID == "TheBarnLogo"){
        theBarnLogoElement = element;
      }

     elementID = elementID.substring(1);
    let findEl = store.unitsData.find((obj:any) => {return obj.unitId === elementID});
    let rectElem = element.querySelector('rect');

    if (rectElem == null) rectElem = element.querySelector('path');
    
    if(elementID.startsWith('building')){
      let findBuilding = store.futurePhaseBuildings.find((obj:any) => {return obj.id == elementID});
      let textElem = element.querySelector('text');
      element.style="pointer-events: none;";
      //TODO make replace to dynamic not static replace
      textElem.style = textElem.getAttribute('style').replace('\'BrandonGrotesque-Bold\', \'Brandon Grotesque\', sans-serif', '\'Brandon Groeteque Bold\'');
      if(findBuilding == null || !findBuilding.enabled 
        || store.floorplanFilter != '' || store.statusFilter != ''){
        element.visibility = 'hidden';
        element.setAttribute('visibility', 'hidden');
      }
    }

    let futurePhase = false;
    if(store.floorplanFilter == '' && store.statusFilter == '')
    store.futurePhaseBuildings.forEach((building:BuildingData) => {
      if(!building.enabled) return;
      if(elementID >= building.startUnit && elementID <= building.endUnit){
        // element.visibility = 'hidden';
        // element.setAttribute('visibility', 'hidden');
        futurePhase = false;
        return;
      }
    });

    if(findEl == null || rectElem == null)
      return;

    let triangleElem;
    let allPaths = element.querySelectorAll('path');
    if(allPaths.length == 2){
      triangleElem = allPaths[1];
    }else if(allPaths.length == 1 && allPaths[0] != rectElem){
      triangleElem = allPaths[0];
    }

    if(triangleElem != null){
        triangleElem.style = "fill:white;pointer-events: none;";
    }

    rectElem.onclick = ()=>{ 
      if(panning) return;
      if(findEl!.status == "AFF") return;
      lotFloorplanName.value = findEl!.floorPlanName;
      selectedLotId.value = findEl!.unitName;
      modalTitleText.value = "Homesite "+findEl!.unitName;
      lotPriceText.value = findEl!.status == "Available"?
      `$${(findEl!.startingPrice*1000).toLocaleString("EN-US")}`: "";
      if(findEl!.status == "ComingSoon") lotPriceText.value = "Coming Soon";
      lotBedroomsText.value = `Bedrooms: ${findEl!.minBedrooms} - ${findEl!.maxBedrooms}`;
      lotBathroomsText.value = `Baths: ${findEl!.minBathrooms} - ${findEl!.maxBathrooms}`;
      lotSizeText.value = `Size: ${findEl!.minSqft.toLocaleString()} - ${findEl!.maxSqft.toLocaleString()} sq. ft.`;
      lotParkingSpaceText.value = `Parking Space: ${findEl!.parkingSpace}-Car Garage`;
      lotUnitInfoText.value = findEl!.infoText;
      showUnitModal.value = true;
      currentFloorplanIndex.value = getFloorplanIndexFromName(findEl!.floorPlanName);
    };

    let textElem = element.querySelector('text');
    //TODO make replace to dynamic not static replace 
    textElem.style = textElem.getAttribute('style').replace('\'BrandonGrotesque-Medium\', \'Brandon Grotesque\', sans-serif', '\'Brandon Groeteque Med\'');
    let prevTextStyle = textElem.getAttribute('style');
    let textColor = "fill:white;";
 


    rectElem.style = getFloorplanStyle(findEl!.floorPlanName, futurePhase ? "ComingSoon":findEl!.status);

    let boundingBox = element.getBBox();
    //console.log(element.getBBox());
    let x = boundingBox.x;//rectElem.x.baseVal.value;
    let y = boundingBox.y;//rectElem.y.baseVal.value;
    let width = boundingBox.width;//rectElem.width.baseVal.value;
    let height = boundingBox.height;//rectElem.height.baseVal.value;
    let xOffset = elementID < 7 || elementID > 66 ? 4 : 4;
    let yOffset = elementID < 7 || elementID > 66 ? 0 : -3;

    if((findEl.status == "Unavailable" || futurePhase || findEl.status == "AFF")
      && store.statusFilter != 'ComingSoon'){
        textColor = "fill:none;"
        //rectElem.onclick = () => {return false};
    }

    let cplace = element.querySelector('circle');
    if(cplace){
      cplace.style = 'cursor: default;pointer-events: none;fill:none;';
    }

    let floorplanCheck = store.floorplanFilter != '' && store.floorplanFilter != findEl?.floorPlanName;
    let statusCheck = store.statusFilter != '' && store.statusFilter != findEl.status;
    let elevatorCheck = showOnlyElevator.value && triangleElem == null;

    if((floorplanCheck || statusCheck || elevatorCheck) && !futurePhase){
      textColor = "fill:grey;"

      if (findEl.status == "AFF"){
        textColor = "fill:none;"
      }

      if(triangleElem != null){
        triangleElem.style = "fill:grey;pointer-events: none;";
      }

      rectElem.style = 'fill:#00000096;cursor: default;';
    }else if(findEl.status == "Sold" && !futurePhase){
      addSoldCircle();
    }else if(findEl.status == "Model" && !futurePhase){
      addModelCircle();
    }else if(findEl.status == "Available" && !futurePhase){
      addAvailableCircle();
    }

    textElem.style = prevTextStyle+=';cursor: default;pointer-events: none;'+textColor;
    
    function addModelCircle() {
      let cx=x+width/2-4+xOffset;
      let cy=y+height/2+3+yOffset;
      let textX=x+width/2-13.5+xOffset;
      let textY=y+height/2+6+yOffset;
      if(cplace!=null) {
        cx=cplace.cx.baseVal.value;
        cy=cplace.cy.baseVal.value;
        textX=cx-13.5;
        textY=cy+4.5;
      }
      var circle2=makeSVG('circle', {class:"tempCircle", cx: cx, cy: cy, r: 30, stroke: '#131E29', 'stroke-width': 4, fill: 'White', style: "default;pointer-events: none;" });
      // var text2=makeSVG('text', { x: textX, y: textY, style: "font-family: 'DIN-Condensed'; font-weight:700;font-size:13px;fill:#00599E; default;pointer-events: none;" });
      // text2.textContent="MODEL";
      element.appendChild(circle2);
      // element.appendChild(text2);
    }

  function addSoldCircle() {
    let cx=x+width/2-4+xOffset;
    let cy=y+height/2+3+yOffset;
    let textX=x+width/2-13+xOffset;
    let textY=y+height/2+6.5+yOffset;
    if(cplace!=null) {
      cx=cplace.cx.baseVal.value;
      cy=cplace.cy.baseVal.value;
      textX=cx-25;
      textY=cy+10;
    }
    var circle=makeSVG('circle', {class:"tempCircle", cx: cx, cy: cy, r: 30, stroke: 'white', 'stroke-width': 3, fill: '#F60808', style: "default;pointer-events: none;" });
    //var text=makeSVG('text', { x: textX, y: textY, style: "font-family: 'D-DIN Condensed'; font-weight:400;font-size:30px;fill:white; default;pointer-events: none;" });
    //text.textContent="SOLD";
    element.appendChild(circle);
    //element.appendChild(text);
  }
   function addAvailableCircle() {
    let cx=x+width/2-4+xOffset;
    let cy=y+height/2+3+yOffset;
    if(cplace!=null) {
      cx=cplace.cx.baseVal.value;
      cy=cplace.cy.baseVal.value;
    }
    var circle=makeSVG('circle', { cx: cx, cy: cy, r: 30, stroke: 'white', 'stroke-width': 3, fill: '#0b7f43', style: "default;pointer-events: none;" });
    element.appendChild(circle);
  }
});
}   


function initPanzoom(){
    var element = document.querySelector('#svgImage');
    let startX = 50;
    let startY = 45;
    let startScale = 2.3;
    if(!isWideScreen.value){
      startX = 45;
      startY = 35;
      startScale = 1.7;
    }

    panzoom = Panzoom(element, {
        maxScale: 5,
        minScale: 1,
        startScale: startScale,
        startY: startY,
        startX: startX,
        animate: true,
        duration: 100,
        cursor: 'default',
        contain:"outside"
      });
    element!.parentElement.addEventListener('wheel', panzoom.zoomWithWheel);

    var timeout:any;
    element.addEventListener('panzoomchange', function(event){
        panning = true;
        // if(event.detail.scale > 1.5){
        //   theBarnLogoElement!.setAttribute('visibility', 'hidden');
        // }else{
        //   theBarnLogoElement!.setAttribute('visibility', 'visible');
        // }
        window.clearTimeout(timeout);
        timeout = setTimeout(() => {
            panning = false;
        }, 100);
    });

    zoomInRef.value.onclick = ()=>{ panzoom.zoomIn(); };
    zoomOutRef.value.onclick = ()=>{ panzoom.zoomOut(); };
    zoomResetRef.value.onclick = ()=>{ 
      panzoom.reset();
      store.floorplanFilter = '';
      store.statusFilter = '';
      showOnlyElevator.value = false;
      iterateSVG();
    };
}

function getFloorplanStyle(floorPlanName:string, lotStatus:string){
  let default_cursor = "pointer"
    if(lotStatus == "AFF"){
      default_cursor = "default";
    }
    switch (floorPlanName) {
        case "The Aberdeen":
            //return lotStatus == "Unavailable" || lotStatus == "ComingSoon" ? 
              //'fill:#D9D2A0FF;stroke:rgb(149,145,144);stroke-width:2px;cursor: default;':
              // if(store.siteFilter.floorPlanName == "The Atwood"){
              //   default_stroke = "white";
              // }
            return `fill:#027A9100;cursor: ${default_cursor};`;
        case "The Cambridge":
            //return lotStatus == "Unavailable" || lotStatus == "ComingSoon" ?
              //'fill:#14779AFF;stroke:rgb(149,145,144);stroke-width:2px;cursor: default;':
            return  `fill:#D0930200;cursor: ${default_cursor};`;
        case "The Edinburgh":
            //return lotStatus == "Unavailable" || lotStatus == "ComingSoon" ?
              //'fill:#C67C7CFF;stroke:rgb(149,145,144);stroke-width:2px;cursor: default;':
            return `fill:#781C5300;cursor: ${default_cursor};`;
        case "The Nottingham":
            return `fill:#BD462700;cursor: ${default_cursor};`;
        default:
            return "";
    }
}



function makeSVG(tag:string, attrs:any) {
    var el= document.createElementNS('http://www.w3.org/2000/svg', tag);
    for (var k in attrs)
        el.setAttribute(k, attrs[k]);
    return el;
}
function getFloorplanIndexFromName(floorplanName:string){
  switch (floorplanName) {
    case 'The Aberdeen':
      return 0;
    case 'The Cambridge':
      return 1;
    case 'The Edinburgh':
      return 2;
    case 'The Nottingham':
      return 3;
    default:
      return 0;
  }
}
function getFilterInfoText(){
  switch(store.floorplanFilter){
     case 'The Bellair':
      return `SHOWING BELLAIR (${unitsAvailable.value} UNITS AVAILABLE)`;
    case 'The Cessna':
      return `SHOWING CESSNA (${unitsAvailable.value} UNITS AVAILABLE)`;
    case 'The Douglas':
      return `SHOWING DOUGLAS (${unitsAvailable.value} UNITS AVAILABLE)`;
    default:
      return ``;
  }
}

function statusToText(status:string){
  switch (status) {
    case "ComingSoon":
        return "Coming Soon"
    default:
      return status;      
  }
}

function getFloorplanURL(){
  switch (currentFloorplanIndex.value) {
        case 0:
            return "";
        case 1:
            return "https://www.eya.com/townhomes/potomac-md/northside/homes-floorplans/cambridge-model";
        case 2:
            return "https://www.eya.com/townhomes/potomac-md/northside/homes-floorplans/edinburgh-model";
        case 3:
            return "https://www.eya.com/townhomes/potomac-md/northside/homes-floorplans/nottingham-model";
        default:
            return "";
    }
}

function getImageURL():string{
  console.log(currentFloorplanIndex.value);
    switch (currentFloorplanIndex.value) {
        case 0:
            return a1.value.src;
        case 1:
            return c1.value.src;
        case 2:
            return e1.value.src;
        case 3:
            return n1.value.src;
        default:
            return a1.value.src;
   }
}

async function downloadSitePlan(){
  store.statusFilter = "";
  store.floorplanFilter = "";
  showOnlyElevator.value = false;
  iterateSVG();

  const svg = document.querySelector('svg');
  if(svg){
    showLoadingModal.value = true;
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    let widthFormatOk = svg.width.baseVal.value.toString() == svg.width.baseVal.valueAsString;
    let heightFormatOk = svg.width.baseVal.value.toString() == svg.height.baseVal.valueAsString;
    let defaultWidth = '';
    let defaultHeight = '';
    if (!widthFormatOk || !heightFormatOk) {
      let viewBox = svg.viewBox.baseVal;
      if(viewBox){
        defaultWidth = svg.width.baseVal.valueAsString;
        defaultHeight = svg.height.baseVal.valueAsString;
        //iOS canvas limit is 4096x4096 pixels
        let scaleRatio = 4096 / viewBox.height;

        svg.setAttribute("width", (Math.floor(viewBox.width * scaleRatio)).toString());
        svg.setAttribute("height", (4096).toString());
        canvas.width = Math.floor(viewBox.width * scaleRatio);
        canvas.height = 4096;
      }
    }
    //theBarnLogoElement!.setAttribute('visibility', 'hidden');

    const xml = new XMLSerializer().serializeToString(svg);
    const img = new Image();
    img.src = 'data:image/svg+xml;base64,' + btoa(xml);

    img.onload = async function() {
    ctx!.fillStyle = "white";
    ctx!.fillRect(0, 0, canvas.width, canvas.height);

    let i = 0;
    let maxAttempts = 25;
    let repeat = true;
    let cycle = [];
    let dataURL = "";

    while (repeat && i < maxAttempts){
      console.log(i);
      ctx!.drawImage(img, 0, 0);
      await new Promise((resolve)=>{
        setTimeout(() => resolve(null), 100)
      })
      dataURL = canvas.toDataURL("image/jpeg", 0.8);
      console.log("Data Size = ",dataURL.length);
      i++;
      cycle[i] = dataURL.length;

      if (dataURL.length >= cycle[i - 1]) repeat = false;
    }
    console.log("Finish draw");
    panzoom.reset();

    svg.setAttribute("width", defaultWidth);
    svg.setAttribute("height", defaultHeight);
    iterateSVG();
    // put file into form data
    var formdata = new FormData();
    formdata.append("siteplanImg", dataURL);
    console.error("Siteplan size:" + dataURL.length)
    const response = await fetch('https://homedesigner.truevistavr.com/fileAPI/siteplan/northside',{
      method: "POST",
      //TODO add some floorplan identifier number so know which page to use
      body: formdata
    })
    .then(res => {
      if(res.ok){
        return res.blob()
      }
      throw new Error('Error occured')
    })
    .then(data  => {
      console.log(data)
      var a = document.createElement("a")
      a.href = window.URL.createObjectURL(data)
      a.download = "EYA Northside - Siteplan.pdf"
      a.click()
      showLoadingModal.value = false
    })
    .catch((error) => {
      console.log(error)
      showLoadingModal.value = false
    })
  }
  } 
} 


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("img", {
      ref_key: "a1",
      ref: a1,
      src: _imports_0,
      hidden: ""
    }, null, 512),
    _createElementVNode("img", {
      ref_key: "c1",
      ref: c1,
      src: _imports_0,
      hidden: ""
    }, null, 512),
    _createElementVNode("img", {
      ref_key: "e1",
      ref: e1,
      src: _imports_1,
      hidden: ""
    }, null, 512),
    _createElementVNode("img", {
      ref_key: "n1",
      ref: n1,
      src: _imports_2,
      hidden: ""
    }, null, 512),
    _createElementVNode("div", _hoisted_1, [
      (isWideScreen.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _cache[29] || (_cache[29] = _createElementVNode("div", { class: "titleText" }, "Explore the available models", -1)),
            _cache[30] || (_cache[30] = _createElementVNode("div", { class: "underTitleText" }, "Select your preferred model to see locations.", -1)),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _cache[15] || (_cache[15] = _createElementVNode("label", { class: "select_label" }, "Select Model", -1)),
                _createElementVNode("label", {
                  class: "select_label show_all",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => {{_isRef(floorplan) //@ts-ignore
 ? floorplan.value = '' : floorplan=''; filterModelChange('')}})
                }, "Show All")
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("button", {
                  class: _normalizeClass({ active_model: _unref(floorplan)=='The Cambridge'}),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (filterModelChange('The Cambridge')))
                }, [
                  _cache[18] || (_cache[18] = _createElementVNode("div", { class: "square cambridge" }, null, -1)),
                  _createElementVNode("div", null, [
                    _cache[16] || (_cache[16] = _createElementVNode("div", { class: "model_title" }, "The Cambridge", -1)),
                    _createElementVNode("div", _hoisted_6, _toDisplayString(cambridgePrice.value), 1)
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_7, [...(_cache[17] || (_cache[17] = [
                    _createElementVNode("img", {
                      class: "eye_img",
                      src: _imports_3
                    }, null, -1)
                  ]))], 512), [
                    [_vShow, _unref(floorplan)=='The Cambridge']
                  ])
                ], 2),
                _createElementVNode("button", {
                  class: _normalizeClass({ active_model: _unref(floorplan)=='The Edinburgh'}),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (filterModelChange('The Edinburgh')))
                }, [
                  _cache[21] || (_cache[21] = _createElementVNode("div", { class: "square edinburgh" }, null, -1)),
                  _createElementVNode("div", null, [
                    _cache[19] || (_cache[19] = _createElementVNode("div", { class: "model_title" }, "The Edinburgh", -1)),
                    _createElementVNode("div", _hoisted_8, _toDisplayString(edinburghPrice.value), 1)
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_9, [...(_cache[20] || (_cache[20] = [
                    _createElementVNode("img", {
                      class: "eye_img",
                      src: _imports_3
                    }, null, -1)
                  ]))], 512), [
                    [_vShow, _unref(floorplan)=='The Edinburgh']
                  ])
                ], 2),
                _createElementVNode("button", {
                  class: _normalizeClass({ active_model: _unref(floorplan)=='The Nottingham'}),
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (filterModelChange('The Nottingham')))
                }, [
                  _cache[24] || (_cache[24] = _createElementVNode("div", { class: "square nottingham" }, null, -1)),
                  _createElementVNode("div", null, [
                    _cache[22] || (_cache[22] = _createElementVNode("div", { class: "model_title" }, "The Nottingham", -1)),
                    _createElementVNode("div", _hoisted_10, _toDisplayString(nottinghamPrice.value), 1)
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_11, [...(_cache[23] || (_cache[23] = [
                    _createElementVNode("img", {
                      class: "eye_img",
                      src: _imports_3
                    }, null, -1)
                  ]))], 512), [
                    [_vShow, _unref(floorplan)=='The Nottingham']
                  ])
                ], 2)
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _cache[26] || (_cache[26] = _createElementVNode("label", { class: "select_label" }, "Status", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(status) ? (status).value = $event : status = $event)),
                onChange: filterStatusChange
              }, [...(_cache[25] || (_cache[25] = [
                _createElementVNode("option", {
                  value: "",
                  selected: ""
                }, "All", -1),
                _createElementVNode("option", { value: "Available" }, "Available", -1),
                _createElementVNode("option", { value: "ComingSoon" }, "Coming Soon", -1),
                _createElementVNode("option", { value: "Sold" }, "Sold", -1)
              ]))], 544), [
                [_vModelSelect, _unref(status)]
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((showOnlyElevator).value = $event)),
                id: "showOnlyElevator",
                onChange: iterateSVG
              }, null, 544), [
                [_vModelCheckbox, showOnlyElevator.value]
              ]),
              _cache[27] || (_cache[27] = _createElementVNode("label", { for: "showOnlyElevator" }, "Show only homes with elevator option", -1))
            ]),
            _createElementVNode("button", {
              class: "downloadButton",
              onClick: downloadSitePlan
            }, [...(_cache[28] || (_cache[28] = [
              _createElementVNode("img", { src: _imports_4 }, null, -1),
              _createTextVNode("DOWNLOAD SITE PLAN", -1)
            ]))]),
            _cache[31] || (_cache[31] = _createStaticVNode("<div class=\"statusLegend\" data-v-1dc773b4><div class=\"legendItem\" data-v-1dc773b4><div class=\"availableCircle\" data-v-1dc773b4></div>Available</div><div class=\"legendItem\" data-v-1dc773b4><div class=\"soldCircle\" data-v-1dc773b4></div>Sold</div><div class=\"legendItem\" data-v-1dc773b4><div class=\"modelCircle\" data-v-1dc773b4></div>Model Home</div><div class=\"legendItem\" data-v-1dc773b4><img class=\"legendIcon\" src=\"" + _imports_5 + "\" data-v-1dc773b4>Elevator Option Available</div></div>", 1))
          ]))
        : _createCommentVNode("", true),
      (!isWideScreen.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [...(_cache[32] || (_cache[32] = [
            _createElementVNode("div", { class: "titleText" }, "Explore the available models", -1),
            _createElementVNode("div", { class: "underTitleText" }, "Select your preferred model to see locations.", -1)
          ]))]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", {
          id: "siteplanImage",
          ref_key: "siteplanImgContainer",
          ref: siteplanImgContainer
        }, [
          _createElementVNode("div", {
            ref_key: "svgDiv",
            ref: svgDiv,
            id: "svgImage"
          }, [...(_cache[33] || (_cache[33] = [
            _createElementVNode("div", { class: "loaderContainer" }, [
              _createElementVNode("div", { class: "loader" })
            ], -1)
          ]))], 512)
        ], 512),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("button", _hoisted_17, [
            _createElementVNode("img", {
              class: "legendButtonImg",
              ref_key: "zoomInRef",
              ref: zoomInRef,
              src: _imports_6
            }, null, 512)
          ]),
          _createElementVNode("button", _hoisted_18, [
            _createElementVNode("img", {
              class: "legendButtonImg",
              ref_key: "zoomOutRef",
              ref: zoomOutRef,
              src: _imports_7
            }, null, 512)
          ]),
          _createElementVNode("button", _hoisted_19, [
            _createElementVNode("img", {
              class: "legendButtonImg",
              ref_key: "zoomResetRef",
              ref: zoomResetRef,
              src: _imports_8
            }, null, 512)
          ])
        ])
      ]),
      (!isWideScreen.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _cache[34] || (_cache[34] = _createElementVNode("label", { class: "select_label" }, "Select Model", -1)),
                _createElementVNode("label", {
                  class: "select_label show_all",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => {{_isRef(floorplan) //@ts-ignore
 ? floorplan.value = '' : floorplan=''; filterModelChange('')}})
                }, "Show All")
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("button", {
                  class: _normalizeClass({ active_model: _unref(floorplan)=='The Cambridge'}),
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (filterModelChange('The Cambridge')))
                }, [
                  _cache[37] || (_cache[37] = _createElementVNode("div", { class: "square cambridge" }, null, -1)),
                  _createElementVNode("div", null, [
                    _cache[35] || (_cache[35] = _createElementVNode("div", { class: "model_title" }, "The Cambridge", -1)),
                    _createElementVNode("div", _hoisted_24, _toDisplayString(cambridgePrice.value), 1)
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_25, [...(_cache[36] || (_cache[36] = [
                    _createElementVNode("img", {
                      class: "eye_img",
                      src: _imports_3
                    }, null, -1)
                  ]))], 512), [
                    [_vShow, _unref(floorplan)=='The Cambridge']
                  ])
                ], 2),
                _createElementVNode("button", {
                  class: _normalizeClass({ active_model: _unref(floorplan)=='The Edinburgh'}),
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (filterModelChange('The Edinburgh')))
                }, [
                  _cache[40] || (_cache[40] = _createElementVNode("div", { class: "square edinburgh" }, null, -1)),
                  _createElementVNode("div", null, [
                    _cache[38] || (_cache[38] = _createElementVNode("div", { class: "model_title" }, "The Edinburgh", -1)),
                    _createElementVNode("div", _hoisted_26, _toDisplayString(edinburghPrice.value), 1)
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_27, [...(_cache[39] || (_cache[39] = [
                    _createElementVNode("img", {
                      class: "eye_img",
                      src: _imports_3
                    }, null, -1)
                  ]))], 512), [
                    [_vShow, _unref(floorplan)=='The Edinburgh']
                  ])
                ], 2),
                _createElementVNode("button", {
                  class: _normalizeClass({ active_model: _unref(floorplan)=='The Nottingham'}),
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (filterModelChange('The Nottingham')))
                }, [
                  _cache[43] || (_cache[43] = _createElementVNode("div", { class: "square nottingham" }, null, -1)),
                  _createElementVNode("div", null, [
                    _cache[41] || (_cache[41] = _createElementVNode("div", { class: "model_title" }, "The Nottingham", -1)),
                    _createElementVNode("div", _hoisted_28, _toDisplayString(nottinghamPrice.value), 1)
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_29, [...(_cache[42] || (_cache[42] = [
                    _createElementVNode("img", {
                      class: "eye_img",
                      src: _imports_3
                    }, null, -1)
                  ]))], 512), [
                    [_vShow, _unref(floorplan)=='The Nottingham']
                  ])
                ], 2)
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _cache[45] || (_cache[45] = _createElementVNode("label", { class: "select_label" }, "Status", -1)),
              _withDirectives(_createElementVNode("select", {
                class: "mobile",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_isRef(status) ? (status).value = $event : status = $event)),
                onChange: filterStatusChange
              }, [...(_cache[44] || (_cache[44] = [
                _createElementVNode("option", {
                  value: "",
                  selected: ""
                }, "All", -1),
                _createElementVNode("option", { value: "Available" }, "Available", -1),
                _createElementVNode("option", { value: "ComingSoon" }, "Coming Soon", -1),
                _createElementVNode("option", { value: "Sold" }, "Sold", -1)
              ]))], 544), [
                [_vModelSelect, _unref(status)]
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((showOnlyElevator).value = $event)),
                id: "showOnlyElevator",
                onChange: iterateSVG
              }, null, 544), [
                [_vModelCheckbox, showOnlyElevator.value]
              ]),
              _cache[46] || (_cache[46] = _createElementVNode("label", { for: "showOnlyElevator" }, "Show only homes with elevator option", -1))
            ]),
            _createElementVNode("button", {
              class: "mobilDownloadButton",
              onClick: downloadSitePlan
            }, [...(_cache[47] || (_cache[47] = [
              _createElementVNode("img", { src: _imports_4 }, null, -1),
              _createTextVNode("DOWNLOAD SITE PLAN", -1)
            ]))]),
            _cache[48] || (_cache[48] = _createStaticVNode("<div class=\"statusLegend\" data-v-1dc773b4><div class=\"legendItem\" data-v-1dc773b4><div class=\"availableCircle\" data-v-1dc773b4></div>Available</div><div class=\"legendItem\" data-v-1dc773b4><div class=\"soldCircle\" data-v-1dc773b4></div>Sold</div><div class=\"legendItem\" data-v-1dc773b4><div class=\"modelCircle\" data-v-1dc773b4></div>Model Home</div><div class=\"legendItem\" data-v-1dc773b4><img class=\"legendIcon\" src=\"" + _imports_5 + "\" data-v-1dc773b4>Elevator Option Available</div></div>", 1))
          ]))
        : _createCommentVNode("", true)
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(UnitModal, {
        isWideScreen: isWideScreen.value,
        show: showUnitModal.value,
        showForm: showEmbedForm.value,
        lotId: selectedLotId.value,
        onClose: _cache[13] || (_cache[13] = ($event: any) => (showUnitModal.value = false, showEmbedForm.value = false))
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_32, _toDisplayString(modalTitleText.value), 1)
        ]),
        body: _withCtx(() => [
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, _toDisplayString(lotFloorplanName.value), 1),
            (lotUnitInfoText.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(lotUnitInfoText.value), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_36, _toDisplayString(lotPriceText.value), 1)
          ]),
          _createElementVNode("img", {
            src: getImageURL(),
            class: "modalImagePreview"
          }, null, 8, _hoisted_37),
          (lotFloorplanName.value != 'The Aberdeen')
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                target: "_parent",
                class: "modalLink",
                href: getFloorplanURL()
              }, "View Floor Plan Details", 8, _hoisted_38))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "formButton",
            onClick: _cache[12] || (_cache[12] = ($event: any) => (showEmbedForm.value = true))
          }, "Contact Me About This Home")
        ]),
        _: 1
      }, 8, ["isWideScreen", "show", "showForm", "lotId"])
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(FilterModal, {
        show: showFilterModal.value,
        onClose: _cache[14] || (_cache[14] = ($event: any) => (showFilterModal.value = false)),
        onFilter: iterateSVG,
        testWidth: 200
      }, {
        header: _withCtx(() => [...(_cache[49] || (_cache[49] = []))]),
        body: _withCtx(() => [...(_cache[50] || (_cache[50] = []))]),
        _: 1
      }, 8, ["show"])
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(LoadingModal, { show: showLoadingModal.value }, null, 8, ["show"])
    ]))
  ], 64))
}
}

})